import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';

export default class ShowsBookingAmountHelper extends Helper {
  @service router!: Services['router'];
  @service session!: Services['session'];
  @service storage!: Services['storage'];

  compute([permission]: [string]): boolean {
    if (!this.session.currentUser?.hasAccessTo(permission)) {
      return false;
    }

    const route = this.router.currentRouteName ?? '';
    const onCalendar =
      route.startsWith('calendar.') || route.startsWith('monthly.');

    return this.storage.bookingAmountConfig || !onCalendar;
  }
}
